<mat-card class="overview-card">
	<mat-card-header class="overview-card-header">
		<h5 class="text-center font-weight-bold ma-1">
			{{ payScale.aircraftModel }} -
			<span class="readonly-label">{{ payScale.jobTitle }}</span>
		</h5>
	</mat-card-header>
	<mat-card-content class="card-content no-padding ">
		<div class="desc-item">
			<div>
				<div fxFlex="50%" class="text-center">
					<h5 mat-line>{{ payScale.perTripPay | currency }}</h5>
					<p mat-line class="readonly-label no-margin-tb">Trip Pay</p>
				</div>

				<div fxFlex="50%" class="text-center">
					<h5 mat-line>{{ payScale.availabilityPay | currency }}</h5>
					<p mat-line class="readonly-label no-margin-tb">Availability Pay</p>
				</div>
			</div>
			<div mat-line class="row pl-1 text-ellipsis margin-top-20">
				<span *ngIf="!payScale.scheduledChanges?.length">&nbsp;</span>
				<mat-error *ngIf="!isFuture(payScale.effectiveStart) && payScale.scheduledChanges[0]?.effectiveDate"
					>Scheduled changes effective on {{ payScale.scheduledChanges[0].effectiveDate | date: 'MMMM-yyyy' }}
				</mat-error>
			</div>
			<div mat-line class="row pl-1 text-xs-right text-ellipsis">
				&nbsp;
				<span *ngIf="isFuture(payScale.effectiveStart)" class="text-xs-muted"
					>New Pay Table effective on {{ payScale.effectiveStart | date: 'MMMM-yyyy' }}</span
				>
			</div>
		</div>
	</mat-card-content>
	<mat-card-actions class="card-action-box">
		<button type="button" color="primary" mat-button (click)="navigate(payScale.payScaleId)">
			Edit
		</button>
		<div fxFlex></div>

		<button type="button" color="primary" mat-button (click)="overview(payScale.payScaleId)">
			Overview
		</button>
	</mat-card-actions>
</mat-card>
